import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  individualSearch: "",
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    updateIndividualSearch: (state, action) => {
      state.individualSearch = action.payload;
    },
  },
});

export const { updateIndividualSearch } = searchSlice.actions;
export default searchSlice.reducer;
